import { Book } from './Book';

export interface IGrade {
  id: string;
  name: string;
  numberOfStudents: number;
  numberOfTeachers: number;
  methods: IGradeMethod[];
}

export interface IGradeUser {
  id: string;
  fullName: string;
  initials: string;
}

export interface IGradeStudent {
  id: string;
  fullName: string;
  isSelected: boolean;
}

export interface IGradeItem {
  id: string;
  name: string;
  isSelected: boolean;
}

export interface IGradeMethod {
  id: string;
  title: string;
}

export interface IGradeAvailableMethod {
  id: string;
  title: string;
  isSelected: boolean;
}

export type Grade = {
  id: string;
  name: string;
  description: string;
  smartschoolId: string;
  smartschoolCode: string;
  isDefault: boolean;
  selected: boolean;
};

export type GradeWithStudents = {
  id: string;
  name: string;
  students: IGradeStudent[];
};

export type StudentsByGrade = {
  studentId: string;
  gradeId: string;
};

export type TeacherGrade = Omit<Grade, 'selected'> & {
  numberOfStudents: number;
  numberOfTeachers: number;
  methods: Book[];
};

export type BackendGrade = {
  id: string;
  name: string;
  description: string;
  smartschool_id: string;
  smartschool_code: string;
  is_default: 1 | 0;
  selected?: boolean;
};

// MAPPERS

export const mapBackendGradeToGrade = (backendGrade: BackendGrade) =>
  ({
    id: backendGrade.id,
    name: backendGrade.name,
    description: backendGrade.description,
    smartschoolId: backendGrade.smartschool_id,
    smartschoolCode: backendGrade.smartschool_code,
    isDefault: Boolean(backendGrade.is_default),
    selected: backendGrade.selected || false,
  } as Grade);

export const getGradesByUserMapper = (response: any): Grade[] =>
  response.data
    .map(mapBackendGradeToGrade)
    .sort((a: Grade, b: Grade) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
